import type { JSX } from 'react';
import { DateTime } from '@ksyos/date-time';
import type { ServiceCode } from '@common/enums';
import { FormParagraphFormGroup } from '@frontend/components/fields/FormParagraphField';
import { useProcessActivityContext } from '@frontend/utils';

export function BariPostSurgeryDateFormGroup(): JSX.Element {
    const { processData } = useProcessActivityContext<ServiceCode.BariPost>();
    const surgeryDate = processData?.datum_operatie;

    return (
        <FormParagraphFormGroup label="Datum operatie">
            {surgeryDate && DateTime.from(surgeryDate).format('DD-MM-YYYY')}
        </FormParagraphFormGroup>
    );
}
